import { z } from 'zod';
import { email } from './common';
import { passwordIsValid } from './password';

export const ResetPasswordFirstStep = z.object({
  email,
});

export const ResetPasswordSecondStep = z.object({
  email,
  pin: z.string().min(1, 'PIN_CODE_REQUIRED'),
  password: passwordIsValid,
});

export const ResetPassword = ResetPasswordFirstStep.and(
  ResetPasswordSecondStep,
);

export const ChangePassword = z.object({
  intent: z.literal('resetPassword'),
  oldPassword: z.string().min(1, 'OLD_PASSWORD_REQUIRED'),
  newPassword: passwordIsValid,
});

export type IChangePassword = z.infer<typeof ChangePassword>;
